const ASPECT_RATIO = 16 / 9;
export const MIN_WIDTH = 1000;
export const MIN_HEIGHT = Math.round(MIN_WIDTH / ASPECT_RATIO);
